import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import App from './App'
import './styles/globals.css'
import { CookieConsentProvider } from './contexts/CookieConsentContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <CookieConsentProvider>
            <App />
          </CookieConsentProvider>
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  </StrictMode>,
)
